(function (factory) {
  const estimator = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = estimator;
  if (typeof document !== 'undefined') estimator.start();
})(function () {
  'use strict';
const {FABRICS,LENGTHS,GROUND_HARDWARE,STORM_MODE,RIDGELINE_CORD,GLOWIRE,STAKES,PATCH_KIT,CUTOUT_AREA,FIXED_SEWN_WEIGHT}=window.SLDEstimatorData.products["simplicity"];

  const FIELD_LABELS = Object.freeze({
    'Fabric/Color * (required)': 'Fabric',
    'Length * (required)': 'Length',
    'Ground Tie Outs * (required)': 'Ground Hardware',
    'Storm Mode Tie Outs * (required)': 'Storm Mode',
    "Ridgeline Cord Options * (required)": 'Ridgeline Cord',
    "Reflective Guyline Cord * (required)": 'Glowire',
    "Tent Stakes * (required)": 'Tent Stakes',
    'Patch Kit * (required)': 'Patch Kit'
  });

  

  
  
  
  
  
  
  
  const DEFAULTS = Object.freeze({
    'Ground Hardware': 'Loops Only',
    'Storm Mode': 'No',
    'Ridgeline Cord': 'None (I will use my own)',
    Glowire: 'None (I will use my own)',
    'Tent Stakes': 'None (I will use my own)',
    'Patch Kit': 'No'
  });

  
  
  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
  const exactText = (value) => String(value || '').trim();

  function selections(scope) {
    const selected = Object.create(null);
    for (const element of scope.querySelectorAll('select')) {
      const label=Object.keys(FIELD_LABELS).find(key=>key.replace(/\s+/g,' ').trim()===String(element.labels&&element.labels[0]&&element.labels[0].textContent||'').replace(/\s+/g,' ').trim());
      if (!own(FIELD_LABELS, label)) continue;
      selected[FIELD_LABELS[label]] = exactText(element.value);
    }
    return selected;
  }

  function preference(choice, field) {
    const value = choice[field];
    return value === undefined || value === '' ? DEFAULTS[field] : value;
  }

  function estimate(choice) {
    if (choice.Fabric === 'Custom Fabric (Please Contact Me First)') return { manual: true };

    const fabric = FABRICS[choice.Fabric];
    const rawLength = LENGTHS[choice.Length];
    if (!fabric || !rawLength) return null;

    const groundChoice = preference(choice, 'Ground Hardware');
    const stormChoice = preference(choice, 'Storm Mode');
    const ridgelineChoice = preference(choice, 'Ridgeline Cord');
    const glowireChoice = preference(choice, 'Glowire');
    const stakesChoice = preference(choice, 'Tent Stakes');
    const patchChoice = preference(choice, 'Patch Kit');

    if (
      !own(GROUND_HARDWARE, groundChoice) || !own(STORM_MODE, stormChoice) ||
      !own(RIDGELINE_CORD, ridgelineChoice) || !own(GLOWIRE, glowireChoice) ||
      !own(STAKES, stakesChoice) || !own(PATCH_KIT, patchChoice)
    ) return null;

    const shapedArea = rawLength * fabric.usableWidth - CUTOUT_AREA;
    const body = shapedArea / 1296 * fabric.density;
    const groundHardware = GROUND_HARDWARE[groundChoice];
    const finished = body + FIXED_SEWN_WEIGHT + groundHardware + STORM_MODE[stormChoice];
    const sack = window.SLDEstimatorData.shared.tarps.mainSackWeight(shapedArea,false,0);
    const total = finished + sack + RIDGELINE_CORD[ridgelineChoice] +
      GLOWIRE[glowireChoice] + STAKES[stakesChoice] + PATCH_KIT[patchChoice];

    return { body, finished, total, sack, groundHardware };
  }

  function start() {
    const root = document.querySelector('[data-sld-simplicity-estimator]');
    if (!root) return;
    const scope = root.closest('product-info') || document;

    function calculate() {
      const result = estimate(selections(scope));
      const results = root.querySelector('[data-sld-estimator-results]');
      const message = root.querySelector('[data-sld-estimator-message]');

      if (!result || result.manual) {
        if (results) results.hidden = true;
        if (message) {
          message.textContent = result && result.manual
            ? 'Custom fabrics require a manual weight estimate. Please contact me before ordering.'
            : 'Select your fabric and length to see the estimated weight.';
        }
        return;
      }

      const tarpWeight = root.querySelector('[data-sld-weight-tarp]');
      const totalWeight = root.querySelector('[data-sld-weight-total]');
      if (tarpWeight) tarpWeight.textContent = result.finished.toFixed(1) + ' oz';
      if (totalWeight) totalWeight.textContent = result.total.toFixed(1) + ' oz';
      if (results) results.hidden = false;
      if (message) message.textContent = '';
    }

    let timer;
    const queue = () => {
      clearTimeout(timer);
      timer = setTimeout(calculate, 75);
    };
    document.addEventListener('change', queue, true);
    document.addEventListener('input', queue, true);
    document.addEventListener('click', queue, true);
    new MutationObserver(queue).observe(scope, {
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'checked', 'selected', 'class', 'aria-checked'],
      childList: true
    });
    calculate();
  }

  return { estimate, selections, start };
});
